import { Breadcrumbs } from 'shared-components';
import { Routes } from '../../app/routes';

export const Debug = () => {
  return (
    <>
      <Breadcrumbs
        crumbs={[
          { display: Routes.DASHBOARD.title, link: Routes.DASHBOARD.link },
          { display: Routes.DEBUG.title, link: Routes.DEBUG.link },
        ]}
      />
      <h1>Debug</h1>

      <button
        onClick={() => {
          throw new Error('This is your first error!');
        }}
      >
        Break the world
      </button>
    </>
  );
};
